import { render, staticRenderFns } from "./MobileTabBar.vue?vue&type=template&id=09b12c92&scoped=true"
import script from "./MobileTabBar.vue?vue&type=script&lang=js"
export * from "./MobileTabBar.vue?vue&type=script&lang=js"
import style0 from "./MobileTabBar.vue?vue&type=style&index=0&id=09b12c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b12c92",
  null
  
)

export default component.exports